{
  "version_info": {
    "major": 2026,
    "minor": 19,
   "git_hash" : "566511a6"
  }
}
